import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const HomeSection = () => {
    const parallaxRef = useRef(null);
    const videoRef = useRef(null);

    const handleParallax = () => {
        if (parallaxRef.current) {
            const scrollY = window.scrollY;
            parallaxRef.current.style.willChange = 'transform';
            parallaxRef.current.style.transform = `translateY(${scrollY * 0.5}px)`;
            setTimeout(() => {
                parallaxRef.current.style.willChange = 'auto';
            }, 500);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleParallax);
        return () => {
            window.removeEventListener('scroll', handleParallax);
        };
    }, []);

    return (
        <>
            <section className="relative h-screen w-full overflow-hidden z-0">
                <motion.div className="absolute top-0 left-0 w-full h-full object-cover z-[-1]" ref={parallaxRef}>
                    <video 
                        ref={videoRef}
                        autoPlay 
                        muted 
                        loop 
                        playsInline
                        preload="auto"
                        className="w-full h-full object-cover aspect-video pointer-events-none" 
                        disablePictureInPicture 
                        controlsList="nodownload nofullscreen noremoteplayback"
                    >
                        <source src="/assets/videos/landing-video.mp4" type="video/mp4" />
                    </video>
                </motion.div>
                <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white text-center">
                    <p className="text-lg">Scroll Down</p>
                    <svg className="w-6 h-6 mx-auto mt-2 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
            </section>
        </>
    );
};

export default HomeSection;
